import React from 'react';
import PropTypes from 'prop-types';
import RequiredFormAnswer from './RequiredFormAnswer';
import { FormLabel } from '@mui/material';

const Question = ({ text, control, options, index, ...props }) => {
  const FormComponent = RequiredFormAnswer;

  return (
    <>
      <FormLabel id={`radiogroup-label-${index}`}>{text}</FormLabel>
      <FormComponent control={control} options={options} aria-labelledby={`radiogroup-label-${index}`} {...props} />
    </>
  );
};

Question.displayName = 'Question';

Question.propTypes = {
  control: PropTypes.object.isRequired,
  text: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  index: PropTypes.string,
  value: PropTypes.any,
};

export default Question;
